import React from "react";
import { FileDown, Share2 } from "lucide-react";
import { toast } from "sonner";
import { WhatsAppIcon } from "./WhatsAppButton";
import { company } from "../mock";

export const CATALOGUE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/catalogue.pdf`;
export const CATALOGUE_DOWNLOAD_URL = `${CATALOGUE_URL}?download=1`;

const shareText = `${company.name} - Product Catalogue (inks, coatings & shade card): ${CATALOGUE_URL}`;

export const shareCatalogue = async () => {
  if (navigator.share) {
    try {
      await navigator.share({ title: `${company.name} Catalogue`, text: shareText, url: CATALOGUE_URL });
      return;
    } catch {
      /* user cancelled - fall through to copy */
    }
  }
  try {
    await navigator.clipboard.writeText(CATALOGUE_URL);
    toast.success("Catalogue link copied", { description: "Paste it into WhatsApp, email or a message to share." });
  } catch {
    toast.info("Catalogue link", { description: CATALOGUE_URL });
  }
};

/**
 * variant: "green" (solid), "white" (on green bg), "outline"
 * compact: single icon+label download button only
 */
const CatalogueButtons = ({ variant = "green", compact = false, className = "" }) => {
  const primary = variant === "white" ? "btn-white" : variant === "outline" ? "btn-outline-dark" : "btn-green";
  const secondary = variant === "white" ? "btn-outline-white" : "btn-outline-dark";
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="catalogue-buttons">
      <a href={CATALOGUE_DOWNLOAD_URL} className={primary} download="Anjaneya-Inks-Catalogue.pdf" data-testid="catalogue-download">
        <FileDown size={16} /> Download Catalogue (PDF)
      </a>
      {!compact && (
        <>
          <a
            href={`https://wa.me/?text=${encodeURIComponent(shareText)}`}
            target="_blank"
            rel="noreferrer"
            className={`btn-whatsapp ${variant === "white" ? "btn-whatsapp--dark" : ""}`}
            data-testid="catalogue-share-whatsapp"
          >
            <WhatsAppIcon size={17} /> Share on WhatsApp
          </a>
          <button type="button" onClick={shareCatalogue} className={secondary} data-testid="catalogue-share">
            <Share2 size={16} /> Copy Link
          </button>
        </>
      )}
    </div>
  );
};

export default CatalogueButtons;
